// import { environments } from 'environments/environment';
import { getPermissions } from 'services/api-iam.service';
import {
  IamNamespaces,
  ISession,
  ISessionData,
  LOCAL_STORAGE_KEY,
  ProcessSessionInput,
} from 'shared/consts/auth.const';
import jwtDecode from 'jwt-decode';
import { _axiosWithAuth } from '@setel/webcommon/exposes/ajax';
import { refreshToken } from 'services/api-ops.service';
import { AxiosError } from 'axios';
// const MAX_REFRESH_RETRIES = 3;
let isCallingRefreshToken = false;

export function getSessionData(): ISessionData | null {
  const session = getSession();

  return session && jwtDecode(session.accessToken);
}

export function getSession(): ISession | null {
  const session: string | null = localStorage.getItem(
    LOCAL_STORAGE_KEY.SESSION
  );
  if (session) {
    return JSON.parse(session);
  }
  return null;
}

export function getLocalStorageItem(key: string, parse = true): unknown {
  try {
    const value = window.localStorage.getItem(key);
    return value && parse ? JSON.parse(value) : value;
  } catch (e) {
    console.error('Error while getting local storage item', e);
    return null;
  }
}

export function setLocalStorageItem(
  key: string,
  value: any,
  stringify = true
): void {
  try {
    const stringValue = stringify ? JSON.stringify(value) : value;
    window.localStorage.setItem(key, stringValue);
  } catch (e) {
    console.error('Error while setting local storage item', e);
  }
}

export function removeLocalStorageItem(key: string) {
  try {
    window.localStorage.removeItem(key);
  } catch (e) {
    console.error('Error while removing local storage item');
  }
}

// export async function verifyLoginState() {
//   const session = getLocalStorageItem(LOCAL_STORAGE_KEY.SESSION);
//   if (!session) {
//     // make sure it will go to login page
//     return null;
//   }
//   // save the session value into context
//   console.log('saving into context');
//   //get permission here.
//   await
// }

// export function getRoles(): string[] {
//   if (environments.enableApiIamRoles) {
//     return this.roles;
//   }

//   const session = getSessionData();
//   const { resource_access } = session || {
//     resource_access: { 'setel-ops': { roles: [] } },
//   };
//   const { roles } = resource_access['setel-ops'];
//   return roles;
// }

export async function setRoles(): Promise<void | string[]> {
  const sessionData = getSessionData();
  if (!sessionData || !sessionData.sub) {
    // no session token in local storage
    // redirect to login page
    return;
  }

  return await getPermissions({
    namespace: sessionData.namespace,
    userId: sessionData.sub,
  });
}

export function saveSession(session: ISession) {
  localStorage.setItem(LOCAL_STORAGE_KEY.SESSION, JSON.stringify(session));
}

export function processSession(
  email: string,
  res: ProcessSessionInput
): ISession {
  const expireDate = new Date();
  expireDate.setSeconds(expireDate.getSeconds() + res.expiresIn);

  const session: ISession = {
    accessToken: res.accessToken,
    refreshToken: res.refreshToken,
    expiresAt: expireDate.toISOString(),
    username: (res.username && res.username.trim()) || '',
    email,
  };
  saveSession(session);
  return session;
}

export function setAccessTokenInHeader(accessToken?: string) {
  // set access-token as header in ajax
  _axiosWithAuth.defaults.headers['access-token'] =
    accessToken || getSession()?.accessToken;
}

export function invalidateAccessTokenInHeader() {
  delete _axiosWithAuth.defaults.headers['access-token'];
}

export function isTokenExpired() {}

export async function renewToken(
  onSuccess: (processedSession: ISession) => void,
  onExpire: () => void
) {
  const prevSession = getSession();
  try {
    const res = await refreshToken(
      prevSession?.refreshToken || '',
      getSessionData()?.namespace || IamNamespaces.SETEL_ADMINS
    );
    onSuccess(processSession(prevSession?.email || '', res));
  } catch (err) {
    //logout
    onExpire();
  }
}

export function setupAfterware(
  // onExpire: () => void,
  setAuthState: (processedSession: ISession) => void
) {
  _axiosWithAuth.interceptors.response.use(
    (res) => res,
    async (error: AxiosError) => {
      if (error.response) {
        // if token expires, refresh it
        if (error.response.status === 401) {
          if (!isCallingRefreshToken) {
            isCallingRefreshToken = true;
            const prevSession = getSession();
            try {
              const refreshRes = await refreshToken(
                prevSession?.refreshToken || '',
                getSessionData()?.namespace || IamNamespaces.SETEL_ADMINS
              );

              setAuthState(
                processSession(prevSession?.email || '', refreshRes)
              );
            } catch (err) {
              console.error('Error while refresh Token: ', err);
            }

            // if (res && refreshRetries < MAX_REFRESH_RETRIES) {
            //   processSession(prevSession?.email || '', res);
            //   setAccessTokenInHeader(res.accessToken);
            //   setAuthState();
            // }
            isCallingRefreshToken = false;
            // Should logout here here
          }
        }
      }

      throw error;
    }
  );
}
